<template>
  <div id="app">
    <div class="page_header">
      <nav-bar :routes="routes"></nav-bar>
    </div>
    <div class="page_body">
      <router-view></router-view>
    </div>
    <div class="page_footer">
      <Footer :routes="routes"></Footer>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: { NavBar, Footer },
  name: "App",
  computed: {
    routes() {
      return this.$router.options.routes;
    },
  },
};
</script>

<style lang="scss">
.page_header {
  position: fixed;
  width: 100%;
  height: 60px;
  z-index: 5;
  top: 0;
  left: 0;
  z-index: 9999;
}

.page_body,
.page_footer {
  position: relative;
}
</style>
